import React from 'react';

interface StyleInputProps {
  label: string;
  type?: string;
  placeholder?: string;
  onChange?: (e: any) => void;
  error?: string;
  className?: string;
  value?: string;
}

function StyleInput({
  label,
  type,
  placeholder,
  onChange,
  error,
  className,
  value
}: StyleInputProps) {
  return (
    <div className={`${className}`}>
      <div className={`px-1 py-2 text-base font-semibold`}>{label}</div>
      <input
        className="w-full rounded-md border-2 px-3 py-2 text-base font-normal text-brand focus:outline-brand lg:px-4  lg:py-3"
        type={type ?? 'text'}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
      <div className="px-1 py-2 text-xs3 font-medium text-red-700 lg:text-xs">{error}</div>
    </div>
  );
}
export default StyleInput;
